import Paginate from "vuejs-paginate"
import LayoutMain from './../../../layouts/LayoutMain.vue';
import Header from "./../../Headers/HeaderForAreLoggedIn/index.vue"
import Footer from "./../../Footers/Footer/index.vue"
import ProgressHUD from "./../../ProgressHUD/index.vue"
import ProductItem from "./ProductItem/index.vue"
import ServiceItem from "./ServiceItem/index.vue"
import Api from "./../../../services/api"

export default {
  name: "MarketBoard",
  components: {
    LayoutMain,
    Header,
    Footer,
    ProgressHUD,
    Paginate,
    ProductItem,
    ServiceItem,
  },
   data() {
    return {
      products: null,
      itemCount: 9,
      rowCount: 3,
      pageCount: null,
      validationMessage: "",
      search: {
        text: "",
        type: "all",
        numberPage: 1,
        countPages: 1,
        limit: 9,
      },
      viewCountry: false,  
      country: "Country and Pronvince/State",
      countries: [],
    }
  },
  watch: {
    $route() {
      this.search.text = this.$route.query.text || ""
      this.search.type = this.$route.query.type || "all"
      this.search.numberPage = +this.$route.query.page || 1

      this.refreshDisplayProducts()
    },
  },
  methods: {
     toggle: function(dropdownName)
    {
      //alert(dropdownName)
       this.dropDowns[dropdownName].open = !this.dropDowns[dropdownName].open;
    },
    
    close: function()
    {
      for (dd in this.dropDowns)
      {
        this.dropDowns[dd].open = false;    
      }
    },
    changeTypeFilter(type) {
      this.country = (["all","product","service"].indexOf(type)<0) ? type : "Country and Pronvince/State";
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          type: type,
        }),
      })
    },
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
        }),
      })
    },
    async refreshDisplayProducts() {
      try {
        this.$refs.progress.show()

        var response = await Api.getProducts(this.search)
        this.products = response.data.results
        var data = response.data.countries
        var countries = [], region = "";

        for(var i=0; i<data.length; i++){
          region = (data[i].region != "") ? ", " + data[i].region : "";
          if(data[i].country != "")
            countries[i] = data[i].country + region
        }  
        
        function uniq(a) {
            return a.sort().filter(function(item, pos, ary) {
                return !pos || item != ary[pos - 1];
            })
        }
        countries = uniq(countries);
        for(var i=0; i<countries.length; i++)
            countries[i] = {"name": countries[i]}
        this.countries = countries;

        this.search.countPages = response.data.pagination.countPages
      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.search.text = this.$route.query.text || ""
    this.search.type = this.$route.query.type || "all"
    this.search.numberPage = +this.$route.query.page || 1

    this.$nextTick().then(() => this.refreshDisplayProducts())
  },

  mounted() {
    // $('.button-collapse').sideNav()
    // $('.button-collapse').sideNav('hide')


    $('.dropdown-trigger').dropdown({
      inDuration: 300,
      outDuration: 225,
      hover: true, // Activate on hover
      constrainWidth: false, // If true, constrainWidth to the size of the dropdown activator.
      belowOrigin: true, // Displays dropdown below the button
      alignment: 'right', // Displays dropdown with edge aligned to the left of button
    })
  },
}
  


// WEBPACK FOOTER //
// ./src/components/Marketplace/MarketBoard/MarketBoard.component.js